<div class="rm-login-wrapper">
  <div class="rm-login-card">
    <div class="brand-header">
      <div class="badge-pill">VIP CONCIERGE PORTAL</div>
      <h1>Relationship Manager</h1>
      <p>Log in to access your assigned Express Plan clients & workspace</p>
    </div>

    <div *ngIf="errorMessage" class="error-alert">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <div class="form-group">
        <label for="email">Official Email Address</label>
        <div class="input-icon-wrap">
          <i class="bi bi-envelope"></i>
          <input
            type="email"
            id="email"
            name="email"
            [(ngModel)]="email"
            required
            placeholder="rm.concierge@weddingly.com"
            class="form-control"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="password">Security Password</label>
        <div class="input-icon-wrap">
          <i class="bi bi-shield-lock"></i>
          <input
            type="password"
            id="password"
            name="password"
            [(ngModel)]="password"
            required
            placeholder="Enter password"
            class="form-control"
          />
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="loading || !email || !password">
        <span *ngIf="!loading"><i class="bi bi-box-arrow-in-right"></i> Access Portal</span>
        <span *ngIf="loading"><span class="spinner-border spinner-border-sm"></span> Authenticating...</span>
      </button>
    </form>

    <div class="portal-footer">
      <span>Need support? Contact Administrator for credential recovery.</span>
    </div>
  </div>
</div>
